export default __webpack_public_path__ + "static/media/brands.9233d1f2.png";